import {
  Box,
  Divider,
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import BlogCard from "components/CMS/BlogCard";
import Link from "next/link";
import * as React from "react";
import GetStartedSection from "../getStartedSection";
import Subscribe from "../subscribe";

type Props = {
  blog: any;
};

export default function SecondarySide({ blog }: Props): React.ReactElement {
  return (
    <Box
      component="aside"
      sx={{
        height: "100%",
        position: "relative",
      }}
    >
      {blog?.relatedBlogs.length > 0 && (
        <Typography variant="h5" component="div" sx={{ mb: 2 }}>
          Related articles
        </Typography>
      )}
      <Stack spacing={2} divider={<Divider />}>
        {blog?.relatedBlogs.map((item) => (
          <Link href={`/blog/${item.slug}`} passHref>
            <MuiLink color="inherit" underline="none">
              <BlogCard blog={item} />
            </MuiLink>
          </Link>
        ))}
      </Stack>
      <Divider sx={{ my: 4 }} />
      <Subscribe />
      <GetStartedSection />
    </Box>
  );
}
